import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-response-dialog',
  templateUrl: './error-response.dialog.html',
  styleUrls: ['./error-response.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ErrorResponseDialog implements OnInit {
  title: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ErrorResponseDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.message = this.data.message;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
